import React from 'react'

import { useTheme } from '@mui/material'

import {
  Handle as RFHandle,
  HandleProps as RFHandleProps,
  Position
} from '@xyflow/react'

type HandleProps = RFHandleProps & { color?: string; sx?: object }

/**
 * A handle (connection port) for reactflow, rendered as a small white dot
 * with a colored ring in the owning node's accent color.
 */
const Handle = React.forwardRef((props: HandleProps, ref: any) => {
  const { color, sx, ...rest } = props

  const theme = useTheme()

  return (
    <RFHandle
      {...rest}
      ref={ref}
      style={{
        height: '9px',
        width: '9px',
        background: theme.palette.common.white,
        border: `2px solid ${color ?? theme.palette.primary.main}`,
        borderRadius: '50%',
        right: props.position === Position.Right ? '-7px' : undefined,
        left: props.position === Position.Left ? '-7px' : undefined,
        ...(sx || {})
      }}
    />
  )
})

Handle.displayName = 'Handle'

export default Handle
export { Position }
